import { Context } from "@nuxt/types"

export default function (context: Context) {
  /**
   * V4 expects this, so it will return JSON instead of HTML
   */
  context.$axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
  context.$axios.defaults.withCredentials = true
}
